import { functions } from '../firebase';
import { httpsCallable } from 'firebase/functions';
import { getEmailContent } from '../emailTemplates';

export const sendQuoteEmail = async ({ to, customerName, quoteNumber, pdfContent, createdAt }) => {
  try {
    const content = getEmailContent('quote', { customerName, quoteNumber, createdAt });
    const sendEmail = httpsCallable(functions, 'sendEmail');
    await sendEmail({
      to,
      subject: content.subject,
      text: content.text,
      html: content.html,
      attachment: pdfContent
        ? { content: pdfContent, filename: `quote_${quoteNumber}.pdf`, type: 'application/pdf' }
        : undefined
    });
    return true;
  } catch (error) {
    console.error('Error sending quote email:', error);
    throw error;
  }
}; 